import React from 'react';
import { Tabs } from 'antd';
import { UploadOutlined, UnorderedListOutlined, HistoryOutlined } from '@ant-design/icons';
import ImportTab from './components/ImportTab';
import ConfigListTab from './components/ConfigListTab';
import TaskHistoryTab from './components/TaskHistoryTab';

const ClientHubZonePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white shadow-sm">
          <div className="px-6 py-4 border-b border-gray-200">
            <h1 className="text-2xl font-semibold text-gray-800">Client Hub Zone 管理</h1>
            <p className="mt-1 text-sm text-gray-500">
              管理客户Hub到Zipcode的Zone区配置，支持导入、查询和历史记录查看
            </p>
          </div>

          <Tabs
            defaultActiveKey="import"
            size="large"
            className="px-4"
            items={[
              {
                key: 'import',
                label: (
                  <span>
                    <UploadOutlined />
                    <span className="ml-2">导入配置</span>
                  </span>
                ),
                children: <ImportTab />
              },
              {
                key: 'config-list',
                label: (
                  <span>
                    <UnorderedListOutlined />
                    <span className="ml-2">配置列表</span>
                  </span>
                ),
                children: <ConfigListTab />
              },
              {
                key: 'task-history',
                label: (
                  <span>
                    <HistoryOutlined />
                    <span className="ml-2">任务历史</span>
                  </span>
                ),
                children: <TaskHistoryTab />
              }
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default ClientHubZonePage;
